module.exports = __webpack_public_path__ + "static/chunks/src/components/part-header/assets/logo-vissa-mobile-light.9f48f91d10fa2da76577a8d4cafc3120.webp";